const LANGUAGE = '674efd362326'

export const saveLanguage = (language: string) => localStorage.setItem(LANGUAGE, language)
export const getLanguage = () => localStorage.getItem(LANGUAGE)
